import { User } from '@geovelo-frontends/commons';
import { useContext } from 'react';

import { AppContext, TPageKey } from '../app/context';

import useImpersonating from './impersonating';

function usePageVisibility() {
  const {
    app: { pageVisibility },
  } = useContext(AppContext);
  const { impersonating } = useImpersonating();

  function isAuthorized(user: User, pageKey: TPageKey) {
    const isDev = !process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development';
    const isAlpha = pageVisibility[pageKey] === 'alpha';
    return !isAlpha || (user && user.isGeovelo) || isDev || impersonating;
  }

  return { isAuthorized };
}

export default usePageVisibility;
